import React from "react";
import { createRoot } from "react-dom/client";
import "./assets/css/index.css";
import App from "./App";
import { encryptStorage } from "./lib/storage";

// Expose encryptStorage on window for dev-mode permission testing.
// Usage in browser console:
//   __dev.setRoles([{ appCode: "fin", permissions: ["manage_masters"] }])
//   __dev.setUser({ id: 999, username: "test", is_custom: 0 })
//   __dev.reload()
if (import.meta.env.DEV) {
  (window as any).__dev = {
    setRoles: (roles: any[]) => encryptStorage.setItem("roles", roles),
    setUser: (user: any) => encryptStorage.setItem("user", user),
    reload: () => window.dispatchEvent(new CustomEvent("personaliaPermissionsUpdated")),
    getRoles: () => encryptStorage.getItem("roles"),
    getUser: () => encryptStorage.getItem("user"),
    clear: () => encryptStorage.clear(),
  };
}

createRoot(document.getElementById("root") as HTMLElement).render(<App />);
